﻿import { defineComponent } from 'vue';

import basket from "./basket.vue"
import calendar from "./calendar.vue"
import passenger_details from "../passenger_details.vue"
import pickup_point from "./pickup.vue"
import sales_group from "./sales_group.vue"
import tour_heading from "./tour_heading.vue"

import { Product } from '../../../services/product';

import { product_detail } from '../../../objects/v1_3/product/product/product_detail';
import { product_detail_seller_information_month } from '../../../objects/v1_3/product/product/product_detail_seller_information_month';
import { trip } from "../../../objects/v1_2/Booking/Trip";
import { product_search_product } from 'modules/tms/booking_engine/objects/v1_3/product/search/product_search_product';

const Prod = new Product();

export default defineComponent({
    name: "tour_details",
    components: {
        basket,
        calendar,
        passenger_details,
        pickup_point,
        sales_group,
        tour_heading
    },
    emits: [
        "Add_To_Cart"
    ],
    props: {
        trip_index: Number
    },
    data() {
        return {
            product: new product_detail() as product_detail,
            tour_ids: [] as string[],
            tour_id: "" as string,
            selected_tour_id: "" as string,
            year: 0 as number,
            month: 0 as number,
            add_on_name: "" as string
        }
    },
    methods: {
        async download_product(tour_id: string) {
            this.tour_id = tour_id;
            this.selected_tour_id = tour_id;
            this.tour_ids = [];

            //wait for the whole sales group so the calendar downloads the capacities of every tour in it
            for (const product of (await Prod.Get_Sales_Group(this.tour_id))?.products ?? []) {
                await Prod.Get_Details(product.tour_id, this.$store);
                this.tour_ids.push(product.tour_id);
            }

            this.product = await Prod.Get_Details(this.tour_id, this.$store);

            if(this.isCalendarAddonTour()) {
                const addonId = import.meta.env.VITE_CALENDAR_ADDON_IDS?.trim();
                await Prod.Get_Details(addonId, this.$store);
                this.add_on_name = this.get_Calendar_Addon_Name();
            }

            if (this.product?.seller_information?.months?.length > 0) {
                this.$refs.calendar.onMonthChange(this.product.seller_information.months[0]);
            }

            this.$refs.sales_group.Download_Sales_Group(this.tour_id);
            this.$refs.sales_group.select_product(this.tour_id);

            await this.$refs.pickup_points.Download_Pickup_Points(this.tour_id);
        },
        Add_To_Cart() {
            this.$emit("Add_To_Cart");
        },
        get_Selected_Date(): string {
            let tripInstance = new trip();
            this.$store.getters.get_Basket.trips.forEach((tripItem: trip) => {
                if (tripItem.tour_id == this.selected_tour_id) {
                    tripInstance = tripItem;
                }
            });
            const dateStr = tripInstance.departure_date ?? "";
            if (!dateStr) return "";
            // Assume input is in format yyyy/m/d or yyyy/mm/dd
            const parts = dateStr.split("/");
            if (parts.length !== 3) return dateStr;
            const [yyyy, m, d] = parts;
            // Pad day and month with leading zeros if needed
            const day = d.padStart(2, "0");
            const month = m.padStart(2, "0");
            return `${day}/${month}/${yyyy}`;
        },
        onMonthChange(year: number, month: number) {
            this.year = year;
            this.month = month;

            this.onCalendarUpdate();
        },
        onDateChange() {
            this.$refs.passenger_details.Collapse_Panel();
        },
        onSelectedTour(tour_id: string) {
            this.selected_tour_id = tour_id;

            this.onCalendarUpdate();
        },
        onCalendarUpdate() {
            this.$refs.calendar.onCalendarUpdate(this.get_Calendar_Tour_Id());
        },
        get_Calendar_Tour_Id(): string {
            //a not for sale tour keeps its own calendar dates and from prices, the selected sales group option is only used for booking
            if (Prod.Is_Not_For_Sale(this.tour_id, this.$store)) {
                return this.tour_id;
            }

            return this.selected_tour_id;
        },
        isMobile(): boolean{
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        goTo(id) {
            const element = document.getElementById(id);
      
            if (element) {
               element.scrollIntoView({
                 block: "center",
                 behavior: "smooth",
               });
            }
            //console.log(element)
        },
        isSmallScreen(): boolean{
            if(window.innerHeight < 800) {
                return true
            }
            else {
                return false
            }
        },
        tempBookingNotes(tourId: string): boolean
        {
            if(tourId == null || tourId == "" || import.meta.env.VITE_TEMP_MESSAGE_TOURS == null || import.meta.env.VITE_TEMP_MESSAGE_TOURS == undefined) {
                return false;
            }
            else
            {
                return (import.meta.env.VITE_TEMP_MESSAGE_TOURS as string[]).includes(tourId);
            }
        },
        getTempBookingNotes(): string {
            if (this.GetBrand().toUpperCase() == "HAG") {
                return "Questions about this tour? Contact us at info@haggisadventures.com or call <span class='text-pink-default font-medium'>+44 (0)131 557 9393</span>"
            } else if (this.GetBrand().toUpperCase() == "HEX") {
                return "Questions about this tour? Contact us at info@highlandexplorertours.com or call <span class='text-pink-default font-medium'>+44 (0)131 558 3738</span>"
            } else {
                return ""
            }
        },
        GetBrand(): string {
            return String(import.meta.env.VITE_DEFAULT_CLASS);
        },
        isAgent_Login(): boolean {
            return this.$store.getters.get_Agent_Login?.valid_login == true;
        },
        isCalendarAddonTour(): boolean {
            const addonTourIds = (import.meta.env.VITE_CALENDAR_ADDON_TOUR_IDS as string)?.trim().split(",") ?? [];
            return addonTourIds.includes(this.selected_tour_id);
        },
        get_Calendar_Addon_Name(): string {
            const addonId = import.meta.env.VITE_CALENDAR_ADDON_IDS?.trim();

            if (!addonId) return '';

            return Prod.Get_Details_Sync(addonId, this.$store)?.name ?? '';
        }

    },
    mounted() {
    }
})